export function detectTrigger(
  text: string,
  cursor: number,
  triggers: string[]
) {
  const left = text.slice(0, cursor);

  const regex = new RegExp(`(?:^|\\s)([${triggers.join("")}])(\\w*)$`);
  const match = left.match(regex);

  if (!match) return null;

  return {
    trigger: match[1],
    query: match[2],
    start: match.index! + match[0].indexOf(match[1]),
  };
}